import { configureStore } from '@reduxjs/toolkit'
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import abApi from '../api/rtkQuery/abApi'
import addonsApi from '../api/rtkQuery/addonsApi'
import analyticsApi from '../api/rtkQuery/analyticsApi'
import { bookConfirmApi } from '../api/rtkQuery/bookConfirmApi'
import { calendarApi } from '../api/rtkQuery/calendarApi'
import countryApi from '../api/rtkQuery/countryApi'
import { couponApi } from '../api/rtkQuery/couponApi'
import currencyApi from '../api/rtkQuery/currencyApi'
import fareFamilyApi from '../api/rtkQuery/fareFamilyApi'
import fareFamilyApiV3 from '../api/rtkQuery/fareFamilyApiV3'
import itineraryApi from '../api/rtkQuery/itineraryApi'
import SrpFareFamilyApi from '../api/rtkQuery/srpFareFamilyApi'
import SRPFlightDetailsApi from '../api/rtkQuery/srpFlightDetailsApi'
import srpFlightResultsApi from '../api/rtkQuery/srpFlightResults'
import tagsApi from '../api/rtkQuery/tagsApi'
import userApi from '../api/rtkQuery/userApi'
import walletApi from '../api/rtkQuery/walletApi'
import walletFAQApi from '../api/rtkQuery/walletFAQApi'
import homepageUSPApi from '../api/rtkQuery/homepageUSPApi'
import giftVoucherApi from '../api/rtkQuery/giftVoucherApi'
import offersApi from '../api/rtkQuery/offersApi'
import popularAirportApi from '../api/rtkQuery/popularAirport'
import { authApi } from '../services/authApi'
import { otpAuthApi } from '../services/otpAuthApi'
import { userDetailsApi } from '../services/userDetailsApi'
import rootReducer, { RootState } from './rootReducer'
// Create the store
const store = configureStore({
    reducer: rootReducer,
    middleware: getDefaultMiddleware =>
        getDefaultMiddleware({
            serializableCheck: {
                // Ignore these action types
                ignoredActions: [],
                // Ignore these paths in the state
                ignoredPaths: []
            }
        })
            // Adding the api middleware enables caching, invalidation, polling, and other features of RTK Query
            .concat(itineraryApi.middleware)
            .concat(currencyApi.middleware)
            .concat(fareFamilyApi.middleware)
            .concat(fareFamilyApiV3.middleware)
            .concat(couponApi.middleware)
            .concat(bookConfirmApi.middleware)
            .concat(calendarApi.middleware)
            .concat(countryApi.middleware)
            .concat(addonsApi.middleware)
            .concat(SRPFlightDetailsApi.middleware)
            .concat(SrpFareFamilyApi.middleware)
            .concat(srpFlightResultsApi.middleware)
            .concat(authApi.middleware)
            .concat(otpAuthApi.middleware)
            .concat(userDetailsApi.middleware)
            .concat(analyticsApi.middleware)
            .concat(tagsApi.middleware)
            .concat(userApi.middleware)
            .concat(abApi.middleware)
            .concat(walletApi.middleware)
            .concat(walletFAQApi.middleware)
            .concat(homepageUSPApi.middleware)
            .concat(giftVoucherApi.middleware)
            .concat(offersApi.middleware)
            .concat(popularAirportApi.middleware),
    devTools: process.env.NODE_ENV !== 'production'
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type AppDispatch = typeof store.dispatch

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export { store }
export const useAppDispatch = () => useDispatch<AppDispatch>()
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
